module.exports = __webpack_public_path__ + "static/img/jinsheng.9efba3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jinsheng.png
// module id = KVae
// module chunks = 21